// extracted by mini-css-extract-plugin
module.exports = {"container":"Share_container__wM8cp","label":"Share_label__2DtqK","list":"Share_list__39skG","item":"Share_item__fNsk3","link":"Share_link__3LXCZ","icon":"Share_icon__3FGF9"};